import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
export function mapDoctorSpecialty(specialty: string): string {
    const s = (specialty || '')
        .replace(/\u200c/g, ' ')
        .replace(/‌/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/ك/g, 'ک')
        .replace(/ي/g, 'ی')
        .trim();
    const escapeRegExp = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const hasPhrase = (text: string, phrase: string) => {
        const pattern = new RegExp(`(^|\u200c|\s)${escapeRegExp(phrase)}(\s|\u200c|$)`);
        return pattern.test(text);
    };
    const whitelist: {
        [key: string]: string[];
    } = {
        'زنان و زایمان': ['زنان و زایمان', 'متخصص زنان و زایمان', 'پزشک متخصص زنان'],
        'قلب و عروق': ['قلب و عروق', 'کاردیولوژی'],
        'ارتوپدی': ['ارتوپدی', 'ارتوپد'],
        'اطفال': ['اطفال', 'متخصص اطفال'],
        'اورولوژی': ['اورولوژی', 'ارولوژی', 'اورولوژي', 'متخصص اورولوژی', 'پزشک متخصص اورولوژی'],
        'ماما': ['ماما', 'مامایی'],
        'داخلی': ['داخلی', 'طب داخلی']
    };
    if (s === 'پزشک عمومی' || s === 'پزشک عمومى' || /(^|\s)پزشک\s+عمومی(\s|$)/.test(s)) {
        return 'عمومی';
    }
    for (const [category, phrases] of Object.entries(whitelist)) {
        for (const phrase of phrases) {
            if (hasPhrase(s, phrase)) {
                return category;
            }
        }
    }
    return 'سایر';
}
